import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { APP_DATE_FORMATS } from '../interface/date-formats.constants';


@Pipe({
  name: 'appDate'
})

export class AppDatePipe implements PipeTransform {

  constructor(private readonly datePipe: DatePipe) {}

  transform(value: Date | string | number | null): string {
    if (!value) {
      return '';
    }

    return (
      this.datePipe.transform(
        value,
        APP_DATE_FORMATS.APP_DATE_FORMAT
      ) ?? ''
    );
  }
    transformWithFormat(value: Date | string | number | null, format: string): string {
    if (!value) {
      return '';
    }

    return (
      this.datePipe.transform(
        value,
        format
      ) ?? ''
    );
  }
}
